module.exports = __webpack_public_path__ + "img/image-not-found.002f5fac.png";